"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var i0 = require("./app.component.scss.shim.ngstyle");
var i1 = require("@angular/core");
var i2 = require("./main/main.component.ngfactory");
var i3 = require("./main/main.component");
var i4 = require("../@fuse/services/config.service");
var i5 = require("@angular/cdk/platform");
var i6 = require("@angular/common");
var i7 = require("./app.component");
var i8 = require("@ngx-translate/core");
var i9 = require("../@fuse/components/navigation/navigation.service");
var i10 = require("../@fuse/services/splash-screen.service");
var i11 = require("../@fuse/services/translation-loader.service");
var styles_AppComponent = [i0.styles];
var RenderType_AppComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_AppComponent, data: {} });
exports.RenderType_AppComponent = RenderType_AppComponent;
function View_AppComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "fuse-main", [], [[1, "fuse-layout-mode", 0]], null, null, i2.View_FuseMainComponent_0, i2.RenderType_FuseMainComponent)), i1.ɵdid(1, 180224, null, 0, i3.FuseMainComponent, [i1.Renderer2, i1.ElementRef, i4.FuseConfigService, i5.Platform, i6.DOCUMENT], null, null)], null, function (_ck, _v) { var currVal_0 = i1.ɵnov(_v, 1).layoutMode; _ck(_v, 0, 0, currVal_0); }); }
exports.View_AppComponent_0 = View_AppComponent_0;
function View_AppComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "fuse-root", [], null, null, null, View_AppComponent_0, RenderType_AppComponent)), i1.ɵdid(1, 49152, null, 0, i7.AppComponent, [i8.TranslateService, i9.FuseNavigationService, i10.FuseSplashScreenService, i11.FuseTranslationLoaderService], null, null)], null, null); }
exports.View_AppComponent_Host_0 = View_AppComponent_Host_0;
var AppComponentNgFactory = i1.ɵccf("fuse-root", i7.AppComponent, View_AppComponent_Host_0, {}, {}, []);
exports.AppComponentNgFactory = AppComponentNgFactory;
